<p-panel header="Einstellungen" class="panel-settings">
  <p-fieldset legend="Anzahl Runden">
    <div class="p-field">
      <p-inputNumber
        id="maxRounds"
        name="maxRounds"
        [(ngModel)]="maxRounds"
        #rounds="ngModel"
        inputId="maxRounds"
        [step]="1"
        [min]="pzService.game"
        [showButtons]="true"
        class="m-t--sm"
        (onInput)="handleChangeMaxRounds()"
        (onBlur)="handleChangeMaxRounds()"
      ></p-inputNumber>
    </div>
  </p-fieldset>
  <br />
  <p-fieldset legend="Startspieler">
    <div class="field-radiobutton">
      <p-radioButton
        name="startPlayerGroup"
        value="player1"
        inputId="player1"
        [(ngModel)]="startPlayer"
        (onClick)="handleChangeStartPlayer()"
      ></p-radioButton>
      <label for="player1" class="clickable">Spieler 1</label>
    </div>
    <div class="field-radiobutton">
      <p-radioButton
        name="startPlayerGroup"
        value="player2"
        inputId="player2"
        [(ngModel)]="startPlayer"
        (onClick)="handleChangeStartPlayer()"
      ></p-radioButton>
      <label for="player2" class="clickable">Spieler 2</label>
    </div>
  </p-fieldset>
  <br />
  <p-fieldset legend="Schätzung verstecken">
    <div class="field-checkbox m-t--sm">
      <p-checkbox
        [(ngModel)]="passwordPriceInputMode"
        [binary]="true"
        inputId="passwordPriceInputMode"
        (onChange)="handleChangePricePasswordMode()"
      ></p-checkbox>
      <label for="passwordPriceInputMode" class="clickable"
        >Schätzung verstecken (***)</label
      >
    </div>
  </p-fieldset>
  <br />
  <p-fieldset legend="Sound">
    <div class="field-checkbox m-t--sm">
      <p-checkbox
        [(ngModel)]="soundOn"
        [binary]="true"
        inputId="soundOn"
        (onChange)="handleChangeSound()"
      ></p-checkbox>
      <label for="soundOn" class="clickable">Sound</label>
    </div>
  </p-fieldset>
  <br />
  <p-fieldset legend="Installation">
    <p-button
      (click)="showTamperMonkeyScript()"
      label="Tampermonkey-Script anzeigen"
    ></p-button>
  </p-fieldset>
</p-panel>

<p-dialog [(visible)]="showTamperMonkeyScriptOverlay">
  <ng-template pTemplate="header"> Tampermonkey-Script </ng-template>
  <h2>1. Chrome browser extension "Tampermonkey" installieren</h2>
  <h2>2. Das folgende Script in Tampermonkey importieren:</h2>
  <textarea
    pInputTextarea
    autoResize="autoResize"
    [(ngModel)]="tamperMonkeyScript"
    class="pz-textarea"
  ></textarea>
</p-dialog>
